import { Component, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import moment from 'moment';
import { Observable, interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserStatusDropdownComponent } from 'src/app/components/fragments/user-status/user-status-dropdown/user-status-dropdown.component';
import { PresenceDurationBrickSettingsStateSelectors } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.selectors';
import { SamwinUserStatusState } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.state';
import { SessionState } from 'src/app/store/session/session.state';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';
import { BasicBrickComponent } from '../../basic-brick-component';

@Component({ template: '' })
export class PresenceDurationBrickBaseComponent extends BasicBrickComponent implements OnInit {
   constructor(private store: Store) {
      super();
   }

   @Select(SamwinUserStatusState.currentStatusInfo)
   public currentUserStatusInfo$: Observable<UserStatusInfoRemoteDto>;

   @Select(SamwinUserStatusState.getNextAutoStatusChangeTime)
   public currentUserStatusDuration$: Observable<moment.Moment>;

   @Select(SessionState.getAuthenticatedUserId)
   public userId: number;

   public now$ = interval(500).pipe(map(() => moment()));

   public userState$: Observable<UserStatusInfoRemoteDto>;
   public showProgress$: Observable<boolean>;
   public showDurationAsText$: Observable<boolean>;
   public isSmallView = false;

   @ViewChild('userStatusDropdown', { static: false }) userStatusDropdown: UserStatusDropdownComponent;

   ngOnInit(): void {
      this.showProgress$ = this.store.select(PresenceDurationBrickSettingsStateSelectors.getIsProgressbarShown).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showDurationAsText$ = this.store.select(PresenceDurationBrickSettingsStateSelectors.getIsTextShown).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   public onBrickClick(): void {
      this.userStatusDropdown.toggleDropdown();
   }
}
